"use client";

import React from "react";

interface IconByNameProps {
  name: string;
  className?: string;
  stroke?: number;
}

export default function IconByName({
  name,
  className,
  stroke = 1,
}: IconByNameProps) {
  const [IconComp, setIconComp] = React.useState<any>(null);

  React.useEffect(() => {
    let isActive = true;
    (async () => {
      try {
        const mod: any = await import("@tabler/icons-react");
        const Comp = mod?.[name];
        if (isActive) setIconComp(Comp || null);
      } catch (_e) {
        if (isActive) setIconComp(null);
      }
    })();
    return () => {
      isActive = false;
    };
  }, [name]);

  if (!IconComp) return null;
  return <IconComp stroke={stroke} className={className} />;
}


